import { PropertyPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack } from '@mui/material';
import React from 'react';

import CardWrapper from '../../CardWrapper';
import Coverages from './Coverages';
import Endorsements from './Endorsements';
import PropertyDetails from './PropertyDetails';

interface Props {
  data: PropertyPolicy;
}

const Details: React.FC<Props> = ({ data }: Props) => {
  return (
    <CardWrapper title="Policy details">
      <Stack spacing={{ mobile: 2, tablet: 3 }}>
        <PropertyDetails
          data={data}
          policyNumber={data.policySummary.policyNumber}
        />
        <Coverages
          data={data.propertyCoverages}
          policyNumber={data.policySummary.policyNumber}
        />
        {data.propertyEndorsements && (
          <Endorsements
            data={data.propertyEndorsements}
            policyNumber={data.policySummary.policyNumber}
          />
        )}
      </Stack>
    </CardWrapper>
  );
};

export default Details;
